/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CartRequestDto } from '../../models/cart-request-dto';
import { CartResponseDto } from '../../models/cart-response-dto';

export interface InitCart$Params {
      body: CartRequestDto
}

export function initCart(http: HttpClient, rootUrl: string, params: InitCart$Params, context?: HttpContext): Observable<StrictHttpResponse<CartResponseDto>> {
  const rb = new RequestBuilder(rootUrl, initCart.PATH, 'put');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CartResponseDto>;
    })
  );
}

initCart.PATH = '/api/v1/cart';
